export enum RoleStatus{
    SuperAdmin = 1,
    Admin = 2,
    SecuritySupervisior = 3,
    User = 4
}